// 高级装备
import { EquipMain } from "../equipmentType";
import { equipTypes } from "../equipConst";
import { propertyName, propertyAttr } from "@/const/character";
// 武器池
const equipPoolListW: EquipMain[] = [
  {
    name: "小太刀",
    describe: "一把精致的小太刀",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 12
      },
      {
        name: propertyName.AS,
        type: propertyAttr.AS,
        isPercent: false,
        value: 0.1
      }
    ],
    grade: 1,
    level: 1,
    icon: 1,
    price: 2
  },
  {
    name: "太刀",
    describe: "一把太刀罢了",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 22
      },
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 10
      }
    ],
    grade: 1,
    level: 5,
    icon: 0,
    price: 10
  },
  {
    name: "暗淡的光剑",
    describe: "这是..光？",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 38
      },
      {
        name: propertyName.DEX,
        type: propertyAttr.DEX,
        isPercent: false,
        value: 15
      }
    ],
    grade: 1,
    level: 10,
    icon: 9,
    price: 20
  },
  {
    name: "短剑",
    describe: "一把短剑",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 72
      },
      {
        name: propertyName.AS,
        type: propertyAttr.AS,
        isPercent: false,
        value: -0.1
      }
    ],
    grade: 1,
    level: 15,
    icon: 17,
    price: 40
  },
  {
    name: "帝国短剑",
    describe: "",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 120
      },
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 30
      },
      {
        name: propertyName.AS,
        type: propertyAttr.AS,
        isPercent: false,
        value: -0.1
      }
    ],
    grade: 1,
    level: 20,
    icon: 17,
    price: 200
  }
];
// 防具池
const equipPoolListA: EquipMain[] = [
  {
    name: "棉布衣",
    describe: "真不戳",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 12
      },
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: 20
      }
    ],
    grade: 1,
    level: 1,
    icon: 2,
    price: 2
  },
  {
    name: "手工布衣",
    describe: "",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 20
      },
      {
        name: propertyName.CRR,
        type: propertyAttr.CRR,
        isPercent: false,
        value: 0.08
      }
    ],
    grade: 1,
    level: 5,
    icon: 2,
    price: 10
  },
  {
    name: "哥布林骨架",
    describe: "",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 70
      },
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 10
      }
    ],
    grade: 1,
    level: 10,
    icon: 12,
    price: 20
  },
  {
    name: "铁甲",
    describe: "",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 100
      },
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 100
      }
    ],
    grade: 1,
    level: 15,
    icon: 10,
    price: 40
  },
  {
    name: "帝国锁子甲盔甲",
    describe: "",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 200
      },
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: 40
      }
    ],
    grade: 1,
    level: 21,
    icon: 18,
    price: 150
  },
  {
    name: "坚毅的钢刃",
    describe: "吹毛断发，无坚不摧",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 150
      },
      {
        name: propertyName.CRR,
        type: propertyAttr.CRR,
        isPercent: false,
        value: 0.1
      }
    ],
    grade: 1,
    level: 24,
    icon: 1,
    price: 400
  },
  {
    name: "野蛮人装甲",
    describe: "男人的味道",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 50
      },
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: 300
      },
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 150
      }
    ],
    grade: 1,
    level: 25,
    icon: 37,
    price: 500
  }
];
// 首饰池
const equipPoolListJ: EquipMain[] = [
  {
    name: "哥布林骨链",
    describe: "哥布林骨头制成的项链，似乎有神秘力量",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 5
      },
      {
        name: propertyName.DEX,
        type: propertyAttr.DEX,
        isPercent: false,
        value: 5
      }
    ],
    grade: 1,
    level: 1,
    icon: 3,
    price: 2
  },
  {
    name: "一点心意",
    describe: "",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: 10
      },
      {
        name: propertyName.DEX,
        type: propertyAttr.DEX,
        isPercent: false,
        value: 10
      }
    ],
    grade: 1,
    level: 5,
    icon: 14,
    price: 10
  },
  {
    name: "精致的项链",
    describe: "",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: 50
      },
      {
        name: propertyName.CRD,
        type: propertyAttr.CRD,
        isPercent: false,
        value: 0.1
      }
    ],
    grade: 1,
    level: 10,
    icon: 15,
    price: 20
  },
  {
    name: "娃娃项链",
    describe: "",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 20
      },
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: 18
      }
    ],
    grade: 1,
    level: 15,
    icon: 14,
    price: 40
  },
  {
    name: "精致的大铁链",
    describe: "",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: 50
      },
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: 100
      }
    ],
    grade: 1,
    level: 20,
    icon: 15,
    price: 200
  },
  {
    name: "爱人的心意",
    describe: "我一定会好好保管他",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: 100
      },
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: 200
      }
    ],
    grade: 1,
    level: 24,
    icon: 22,
    price: 380
  }
];

const equipsGrade1: EquipMain[] = [
  ...equipPoolListW,
  ...equipPoolListA,
  ...equipPoolListJ
];
export { equipsGrade1 };
